<script>
export default {
  name: "QuizView",
  data() {
    return {
      currentQuestion: 0,
      selectedAnswers: {},
      openAnswer: '',
      showResults: false,
      quizStarted: false,
      questions: [
        {
          id: 1,
          question: "IN CHE ANNO NACQUE FRANCESCO D'ASSISI?",
          type: "multiple",
          options: [
            { id: "A", text: "1176", correct: false },
            { id: "B", text: "1231", correct: false },
            { id: "C", text: "1099", correct: false },
            { id: "D", text: "1182", correct: true }
          ]
        },
        {
          id: 2,
          question: "FRANCESCO ERA IL FIGLIO DI UN FABBRO RICCO?",
          type: "boolean",
          options: [
            { id: "A", text: "VERO", correct: false },
            { id: "B", text: "FALSO", correct: true }
          ]
        },
        {
          id: 3,
          question: "QUALI SONO GLI AMICI ANIMALI DI FRANCESCO?",
          type: "multiple",
          options: [
            { id: "A", text: "UCCELLI, AQUILE E SERPENTI", correct: false },
            { id: "B", text: "MAIALI, UCCELLI E TORTORE", correct: true },
            { id: "C", text: "TORTORE, MAIALI E PAPPAGALLI", correct: false },
            { id: "D", text: "MAIALI, MUCCHE E CERVI", correct: false }
          ]
        },
        {
          id: 4,
          question: "PER FRANCESCO OGNI CREATURA È UN DONO E TROVAVA FELICITÀ IN OGNI ELEMENTO.",
          type: "boolean",
          options: [
            { id: "A", text: "VERO", correct: true },
            { id: "B", text: "FALSO", correct: false }
          ]
        },
        {
          id: 5,
          question: "SAN FRANCESCO HA FATTO UN MIRACOLO CON UNO DI QUESTI ANIMALI, QUALE?",
          type: "multiple",
          options: [
            { id: "A", text: "SERPENTE", correct: false },
            { id: "B", text: "CANGURO", correct: false },
            { id: "C", text: "LUPO", correct: true },
            { id: "D", text: "AQUILA", correct: false }
          ]
        },
        {
          id: 6,
          question: "PER FRANCESCO ESSERE MISERICORDIOSI SIGNIFICA",
          type: "multiple",
          options: [
            { id: "A", text: "SAPER PERDONARE", correct: true },
            { id: "B", text: "DONARE AI POVERI", correct: false },
            { id: "C", text: "SCUSARSI COL PROSSIMO", correct: false }
          ]
        },
        {
          id: 7,
          question: "QUAL'È LA COSA CHE TI HA PIÙ COLPITO DELLA LEZIONE DI OGGI?",
          type: "open",
          options: []
        }
      ]
    }
  },
  computed: {
    totalQuestions() {
      return this.questions.length - 1; // Escludi domanda aperta dal conteggio
    },
    correctAnswers() {
      let correct = 0;
      this.questions.forEach(q => {
        if (q.type === 'open') return; // Salta domanda aperta
        const selected = this.selectedAnswers[q.id];
        const correctOption = q.options.find(opt => opt.correct);
        if (selected === correctOption.id) {
          correct++;
        }
      });
      return correct;
    },
    percentage() {
      return Math.round((this.correctAnswers / this.totalQuestions) * 100);
    },
    resultMessage() {
      if (this.percentage === 100) return "Perfetto! Sei un esperto della vita di San Francesco! 🌟";
      if (this.percentage >= 80) return "Ottimo lavoro! Conosci molto bene San Francesco! 👏";
      if (this.percentage >= 60) return "Bene! Hai una buona conoscenza di San Francesco! 📚";
      if (this.percentage >= 40) return "Discreto! Continua a studiare la vita di San Francesco! 💪";
      return "Dai, puoi fare di meglio! Rileggi la storia di San Francesco! 📖";
    },
    resultColor() {
      if (this.percentage >= 80) return "#4caf50";
      if (this.percentage >= 60) return "#ffd93d";
      if (this.percentage >= 40) return "#ff9800";
      return "#f44336";
    }
  },
  methods: {
    startQuiz() {
      this.quizStarted = true;
    },
    selectAnswer(questionId, answerId) {
      this.selectedAnswers[questionId] = answerId;
    },
    nextQuestion() {
      if (this.currentQuestion < this.questions.length - 1) {
        this.currentQuestion++;
      }
    },
    prevQuestion() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
      }
    },
    submitQuiz() {
      if (this.currentQuestion === this.questions.length - 1) {
        this.showResults = true;
      }
    },
    restartQuiz() {
      this.currentQuestion = 0;
      this.selectedAnswers = {};
      this.openAnswer = '';
      this.showResults = false;
      this.quizStarted = false;
    },
    isAnswered(questionId) {
      return this.selectedAnswers[questionId] !== undefined || 
             (questionId === 7 && this.openAnswer.trim() !== '');
    }
  }
}
</script>

<template>
  <div class="quiz-container">
    <!-- Intro Screen -->
    <div v-if="!quizStarted && !showResults" class="quiz-intro">
      <div class="intro-icon">
        <i class="fa fa-question-circle"></i>
      </div>
      <h1 style="color: #fb4242">Quiz su San Francesco d'Assisi</h1>
      <p class="intro-text">
        Metti alla prova la tua conoscenza sulla vita e gli insegnamenti di San Francesco! 
        Rispondi a {{ totalQuestions }} domande e scopri quanto hai imparato.
      </p>
      <div class="quiz-info">
        <div class="info-card">
          <i class="fa fa-list"></i>
          <span>{{ totalQuestions }} Domande</span>
        </div>
        <div class="info-card">
          <i class="fa fa-pencil"></i>
          <span>1 Domanda Aperta</span>
        </div>
        <div class="info-card">
          <i class="fa fa-clock-o"></i>
          <span>~5 minuti</span>
        </div>
      </div>
      <button @click="startQuiz" class="start-button">
        <i class="fa fa-play"></i> Inizia il Quiz
      </button>
    </div>

    <!-- Quiz Questions -->
    <div v-if="quizStarted && !showResults" class="quiz-content">
      <div class="quiz-progress">
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: ((currentQuestion + 1) / questions.length * 100) + '%' }"></div>
        </div>
        <span class="progress-text">Domanda {{ currentQuestion + 1 }} di {{ questions.length }}</span>
      </div>

      <div class="question-card">
        <div class="question-number">Domanda {{ currentQuestion + 1 }}</div>
        <h2 class="question-text">{{ questions[currentQuestion].question }}</h2>

        <!-- Multiple choice / Boolean -->
        <div v-if="questions[currentQuestion].type !== 'open'" class="options-container">
          <button
            v-for="option in questions[currentQuestion].options"
            :key="option.id"
            @click="selectAnswer(questions[currentQuestion].id, option.id)"
            :class="[
              'option-button',
              { 'selected': selectedAnswers[questions[currentQuestion].id] === option.id }
            ]"
          >
            <span class="option-id">{{ option.id }}</span>
            <span class="option-text">{{ option.text }}</span>
            <i v-if="selectedAnswers[questions[currentQuestion].id] === option.id" 
               class="fa fa-check-circle option-check"></i>
          </button>
        </div>

        <!-- Open question -->
        <div v-else class="open-answer-container">
          <textarea
            v-model="openAnswer"
            placeholder="Scrivi qui la tua risposta..."
            class="open-answer-input"
            rows="6"
          ></textarea>
        </div>
      </div>

      <div class="quiz-navigation">
        <button 
          @click="prevQuestion" 
          :disabled="currentQuestion === 0"
          class="nav-button prev-button"
        >
          <i class="fa fa-arrow-left"></i> Precedente
        </button>
        
        <button 
          v-if="currentQuestion < questions.length - 1"
          @click="nextQuestion"
          :disabled="!isAnswered(questions[currentQuestion].id)"
          class="nav-button next-button"
        >
          Successiva <i class="fa fa-arrow-right"></i>
        </button>

        <button 
          v-else
          @click="submitQuiz"
          :disabled="!isAnswered(questions[currentQuestion].id)"
          class="nav-button submit-button"
        >
          <i class="fa fa-check"></i> Invia Risposte
        </button>
      </div>
    </div>

    <!-- Results Screen -->
    <div v-if="showResults" class="quiz-results">
      <div class="result-icon">
        <i class="fa fa-trophy"></i>
      </div>
      <h1 style="color: white">Risultati del Quiz</h1>
      
      <div class="score-circle" :style="{ borderColor: resultColor }">
        <div class="score-number" :style="{ color: resultColor }">{{ percentage }}%</div>
        <div class="score-label">Punteggio</div>
      </div>

      <div class="score-details">
        <div class="detail-item">
          <i class="fa fa-check-circle" style="color: #4caf50;"></i>
          <span>Risposte Corrette: <strong>{{ correctAnswers }}</strong></span>
        </div>
        <div class="detail-item">
          <i class="fa fa-times-circle" style="color: #f44336;"></i>
          <span>Risposte Sbagliate: <strong>{{ totalQuestions - correctAnswers }}</strong></span>
        </div>
      </div>

      <div class="result-message" :style="{ borderLeftColor: resultColor }">
        {{ resultMessage }}
      </div>

      <div v-if="openAnswer" class="open-answer-display">
        <h3>La tua risposta personale:</h3>
        <p>"{{ openAnswer }}"</p>
      </div>

      <div class="result-actions">
        <button @click="restartQuiz" class="restart-button">
          <i class="fa fa-refresh"></i> Riprova il Quiz
        </button>
        <router-link to="/vita" class="back-button">
          <i class="fa fa-arrow-left"></i> Torna alla Vita
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
.quiz-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 80vh;
}

/* Intro Screen */
.quiz-intro {
  text-align: center;
  padding: 60px 20px;
}

.intro-icon {
  font-size: 5em;
  color: #fb4242;
  margin-bottom: 20px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}

.intro-text {
  color: #dcdbdb;
  font-size: 1.2em;
  line-height: 1.6;
  margin: 30px auto;
  max-width: 600px;
}

.quiz-info {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 40px 0;
  flex-wrap: wrap;
}

.info-card {
  background: #181a1c;
  padding: 20px 30px;
  border-radius: 10px;
  border: 2px solid #fb4242;
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
}

.info-card i {
  color: #fb4242;
  font-size: 1.5em;
}

.start-button {
  background: linear-gradient(135deg, #fb4242, #ff6b6b);
  color: white;
  font-size: 1.3em;
  padding: 20px 50px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 5px 20px rgba(251, 66, 66, 0.4);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: bold;
}

.start-button:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(251, 66, 66, 0.6);
}

/* Quiz Content */
.quiz-content {
  animation: fadeIn 0.5s;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.quiz-progress {
  margin-bottom: 40px;
}

.progress-bar {
  width: 100%;
  height: 10px;
  background: #2a2c2e;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #fb4242, #ff6b6b);
  transition: width 0.3s ease;
  border-radius: 10px;
}

.progress-text {
  color: #9f9d9d;
  font-size: 0.9em;
}

.question-card {
  background: #181a1c;
  padding: 40px;
  border-radius: 15px;
  margin-bottom: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

.question-number {
  color: #fb4242;
  font-size: 0.9em;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 15px;
}

.question-text {
  color: white;
  font-size: 1.5em;
  line-height: 1.4;
  margin-bottom: 30px;
}

.options-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.option-button {
  background: #2a2c2e;
  border: 2px solid transparent;
  padding: 20px;
  border-radius: 10px;
  color: white;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 15px;
  text-align: left;
  font-size: 1.1em;
}

.option-button:hover {
  background: #3a3c3e;
  border-color: #fb4242;
}

.option-button.selected {
  background: rgba(251, 66, 66, 0.2);
  border-color: #fb4242;
}

.option-id {
  background: #fb4242;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.option-text {
  flex-grow: 1;
}

.option-check {
  color: #4caf50;
  font-size: 1.5em;
}

.open-answer-container {
  margin-top: 20px;
}

.open-answer-input {
  width: 100%;
  background: #2a2c2e;
  border: 2px solid #3a3c3e;
  border-radius: 10px;
  padding: 20px;
  color: white;
  font-size: 1.1em;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.3s;
}

.open-answer-input:focus {
  outline: none;
  border-color: #fb4242;
}

.quiz-navigation {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.nav-button {
  padding: 15px 30px;
  border: none;
  border-radius: 10px;
  font-size: 1.1em;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 10px;
}

.prev-button {
  background: #2a2c2e;
  color: white;
}

.prev-button:hover:not(:disabled) {
  background: #3a3c3e;
}

.next-button {
  background: #fb4242;
  color: white;
  margin-left: auto;
}

.next-button:hover:not(:disabled) {
  background: #ff5252;
}

.submit-button {
  background: linear-gradient(135deg, #4caf50, #66bb6a);
  color: white;
  margin-left: auto;
}

.submit-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #66bb6a, #81c784);
}

.nav-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Results Screen */
.quiz-results {
  text-align: center;
  padding: 40px 20px;
  animation: fadeIn 0.5s;
}

.result-icon {
  font-size: 5em;
  color: #ffd93d;
  margin-bottom: 20px;
  animation: bounce 2s infinite;
}

.score-circle {
  width: 200px;
  height: 200px;
  border: 8px solid;
  border-radius: 50%;
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
}

.score-number {
  font-size: 3em;
  font-weight: bold;
}

.score-label {
  color: #9f9d9d;
  font-size: 1.1em;
  margin-top: 5px;
}

.score-details {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin: 30px 0;
  flex-wrap: wrap;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #dcdbdb;
  font-size: 1.1em;
}

.detail-item i {
  font-size: 1.5em;
}

.result-message {
  background: #181a1c;
  padding: 25px;
  border-radius: 10px;
  border-left: 5px solid;
  font-size: 1.3em;
  color: white;
  margin: 30px auto;
  max-width: 600px;
}

.open-answer-display {
  background: rgba(251, 66, 66, 0.1);
  padding: 30px;
  border-radius: 10px;
  margin: 30px auto;
  max-width: 600px;
  border: 2px solid rgba(251, 66, 66, 0.3);
}

.open-answer-display h3 {
  color: #fb4242;
  margin-bottom: 15px;
}

.open-answer-display p {
  color: #dcdbdb;
  font-size: 1.1em;
  font-style: italic;
  line-height: 1.6;
}

.result-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  flex-wrap: wrap;
}

.restart-button,
.back-button {
  padding: 15px 30px;
  border-radius: 10px;
  font-size: 1.1em;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.restart-button {
  background: #fb4242;
  color: white;
  border: none;
}

.restart-button:hover {
  background: #ff5252;
  transform: translateY(-3px);
}

.back-button {
  background: transparent;
  color: #fb4242;
  border: 2px solid #fb4242;
}

.back-button:hover {
  background: rgba(251, 66, 66, 0.1);
}

@media (max-width: 768px) {
  .quiz-container {
    padding: 20px 10px;
  }

  .question-card {
    padding: 25px;
  }

  .question-text {
    font-size: 1.2em;
  }

  .option-button {
    padding: 15px;
    font-size: 1em;
  }

  .quiz-navigation {
    flex-direction: column;
  }

  .next-button,
  .submit-button {
    margin-left: 0;
  }

  .result-actions {
    flex-direction: column;
  }

  .score-circle {
    width: 150px;
    height: 150px;
  }

  .score-number {
    font-size: 2.5em;
  }
}
</style>
